<template>
    <form @submit.prevent="onSubmit">
        <div class="form-group">
            <label>Tên đề thi</label>
            <input :value="examCode" class="form-control" readonly />
        </div>
        <div class="form-group" style="display: flex; flex-direction: column">
          <label>Chọn file câu hỏi (.json)</label>
          <div v-if="fileName" class="mt-2 text-success">Đã chọn: {{ fileName }}</div>
          <label v-else class="btn btn-warning" for="upload-file" style="width: 130px">
            <input type="file" style="display: none" id="upload-file" @change="onFileChange" accept=".json" />
            <i class="el-icon-top" style="color: white"></i>
            Tải lên
          </label>
        </div>
        <div class="d-flex justify-content-end mt-4">
            <button type="button" class="btn btn-light mr-2" @click="onClose">Huỷ</button>
            <button type="submit" class="btn btn-primary" :disabled="!parsedQuestions || loading">
                <span v-if="loading" class="spinner-border spinner-border-sm mr-1"></span>
                Xác nhận
            </button>
        </div>
    </form>
</template>

<script>
export default {
    name: 'ImportQuestionModal',
    props: { 
        examId: Number,
        examCode: String
    },
    data() {
        return {
            fileName: '',
            parsedQuestions: null,
            loading: false
        }
    },
    methods: {
        onClose() {
            this.$emit('close');
        },
        onFileChange(e) {
            const file = e.target.files[0];
            if (!file) return;
            if (!file.name.endsWith('.json')) {
                this.$toast.error('Chỉ chấp nhận file .json');
                return;
            }
            this.fileName = file.name;
            const reader = new FileReader();
            reader.onload = (evt) => {
                try {
                    const json = JSON.parse(evt.target.result);
                    if (!Array.isArray(json)) throw new Error('Not array');
                    this.parsedQuestions = json;
                } catch (err) {
                    this.parsedQuestions = null;
                    this.$toast.error('File không hợp lệ. Vui lòng kiểm tra lại nội dung JSON.');
                }
            };
            reader.readAsText(file);
        },
        async onSubmit() {
            if (!this.parsedQuestions) {
                this.$toast.error('Vui lòng chọn file hợp lệ!');
                return;
            }
            this.loading = true;
            this.$store.dispatch('IMPORT_MARKING_QUESTION', {
                exam_id: this.examId,
                data: this.parsedQuestions
            }).then((data) => {
                this.$message.success('Import câu hỏi thành công');
                this.$emit('close');
            }).catch((error) => {
                this.$message.error('Import thất bại, vui lòng kiểm tra lại dữ liệu JSON');
            }).finally(() => {
                this.loading = false;
            });
        }
    }
}
</script>